<div>
  <div>
    <div class="row mb-5">
      <div class="col-md-9">
        <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
          As the Company is being operated passively, please provide information regarding the salary of the
          person handling the daily operations of the Company.
        </div>
      </div>
      <div class="col-md-3">
        <button id="manger-salary-edit-ownership-btn" class="button secondary__button large__button half-rounded__button" (click)="gotoOwnership()"
          *ngIf="!currentReport?.isLocked">
          Edit Ownership
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="label">General Manager Salary</div>
        <div class="color-secondary-gray font-size-14 font-weight-normal">
          What is the salary of the general manager or the employee that handles the daily operations of the
          company during the owner’s absence?
        </div>
      </div>
    </div>

    <form #managerSalaryForm="ngForm" novalidate="novalidate" autocomplete="off">

      <ng-container *ngIf="currentReport?.LATEST">

        <div class="row">
          <div class="col-md-10">

            <label class="checkbox large">
              <input class="checkbox__input" type='checkbox' name="manualSalaryCheck" id="manualSalaryCheck"
                [value]="true" [(ngModel)]="isManual" [disabled]="currentReport?.isLocked" />
              <div class="checkbox__data pl-0">
                <div class="checkbox__indicator"></div>
                <p class="checkbox__text">I want to adjust salary manually for each year<br />
                  <span class="font-size-14 font-weight-normal">By default – the system assumes a consistent salary for
                    all
                    years including interim</span>
                </p>
              </div>
            </label>

          </div>
          <div class="col-md-2 text-right">
            <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
          </div>
        </div>

        <ng-container *ngIf="!isManual">
          <div class="row">
            <div class="col-md-12">

              <div class="checkbox__wrapper">

                <number-input [(ngModel)]="common_GM_SALARY"
                  [classes]="'input input__large input__blue'"
                  #common_GM_SALARY_1="ngModel"
                  [required]="true"
                  [disabled]="currentReport?.isLocked"
                  name="common_GM_SALARY_1"
                  (blur)="saveCommonData('GM_SALARY')"
                  [allowZero]="true"
                  [clearZero]="false"
                  [placeholder]="'e.g. 2500'"
                  id="common_GM_SALARY_1"></number-input>

                <div class="checkbox__wrap">
                  <label class="checkbox large">
                    <input class="checkbox__input" type='checkbox' name="inlineFormCheck" id="inlineFormCheck"
                      [value]="true" [(ngModel)]="common_GM_SALARY_TAX" (change)="saveCommonData('GM_SALARY_TAX')"
                      [disabled]="currentReport?.isLocked"/>
                    <div class="checkbox__data">
                      <div class="checkbox__indicator"></div>
                      <p class="checkbox__text">Includes employer payroll taxes</p>
                    </div>
                  </label>
                </div>
              </div>

            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="isManual">
          <ng-container *ngFor="let iyl of incomeYearList; let i = index">
            <div class="row mb-3 position-relative">
              <div class="col-md-12">
                <div class="year">{{iyl.YEAR}}</div>

                <div class="checkbox__wrapper">

                  <ng-container *ngIf="iyl.FINANCIAL_TYPE != 'NOT_AVAILABLE'">
                    <number-input [(ngModel)]="iyl.GM_SALARY"
                      [classes]="'input input__large input__blue'"
                      #GM_SALARY="ngModel"
                      [required]="true"
                      [disabled]="currentReport?.isLocked"
                      name="GM_SALARY_{{i}}"
                      (blur)="callUpdateAPI('GM_SALARY', iyl)"
                      [allowZero]="true"
                      [clearZero]="false"
                      id="GM_SALARY_{{i}}"></number-input>
                  </ng-container>

                  <ng-container *ngIf="iyl.FINANCIAL_TYPE == 'NOT_AVAILABLE'">
                    <input type="text" id="GM_SALARY_NA_{{i}}"
                        class="input input__large input__blue" disabled [value]="'0'">
                  </ng-container>

                  <div class="checkbox__wrap">
                    <label class="checkbox large">
                      <input class="checkbox__input" type='checkbox' name="checkbox{{iyl.YEAR}}"
                        id="checkbox{{iyl.YEAR}}" [value]="true" [(ngModel)]="iyl.GM_SALARY_TAX"
                        (change)="callUpdateAPI('GM_SALARY_TAX', iyl)"
                        [disabled]="currentReport?.isLocked || iyl.FINANCIAL_TYPE == 'NOT_AVAILABLE'"/>
                      <div class="checkbox__data">
                        <div class="checkbox__indicator"></div>
                        <p class="checkbox__text">Includes employer payroll taxes</p>
                      </div>
                    </label>
                  </div>

                </div>

              </div>
            </div>
          </ng-container>
        </ng-container>


        <div class="row my-5">
          <div class="col-md-12">
            <div class="d-flex align-items-center justify-content-between">
              <div class="label">Fair Market Replacement Salary</div>
              <div class="font-size-14 font-weight-bold color--blue">REQUIRED</div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="row form-inline">

              <div class="col-md-8">
                What would be the fair market salary for a general manager of this Company?
              </div>

              <div class="col-md-4">
                <div class="checkbox__wrapper">

                  <number-input [(ngModel)]="currentReport.LATEST.UNNAMED_SALARY"
                    [classes]="'input input__large input__blue'"
                    #UNNAMED_SALARY="ngModel"
                    [required]="true"
                    name="UNNAMED_SALARY"
                    (blur)="callVersionDetailsUpdateAPI('UNNAMED_SALARY')"
                    [disabled]="currentReport.LATEST.ASSISTED_GM_SALARY || currentReport?.isLocked"
                    [allowZero]="true"
                    [clearZero]="false"
                    id="UNNAMED_SALARY"></number-input>

                  <div class="checkbox__wrap">
                    <label class="checkbox large">
                      <input class="checkbox__input" type='checkbox' name="ASSISTED_GM_SALARY" id="ASSISTED_GM_SALARY"
                        [value]="true" [checked]="!currentReport.LATEST.ASSISTED_GM_SALARY"
                        [disabled]="currentReport?.isLocked"
                        (change)="currentReport.LATEST.ASSISTED_GM_SALARY = !currentReport.LATEST.ASSISTED_GM_SALARY; callVersionDetailsUpdateAPI('ASSISTED_GM_SALARY')" />
                      <div class="checkbox__data">
                        <div class="checkbox__indicator"></div>
                        <p class="checkbox__text">Manually</p>
                      </div>
                    </label>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </ng-container>

    </form>

  </div>
</div>
<report-footer [nextBtnEnable]="managerSalaryForm.valid || currentReport?.isLocked" 
  (buttonClicked)="footerButtonClick($event)" [pageId]="reportPageConst.OWNERS_SALARY">
</report-footer>

